// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__a-U2x","errors":"Errors_errors__1Z0rc"};